import { ref } from 'vue'
import { Auth } from './apps/go/interfaces/AuthInterface'
export const auth = ref<Auth>(JSON.parse(localStorage.auth || '{}'))
